import { IssueCard } from "./IssueCard";
import type { Issue } from "../services/db/schema";

interface IssueGridProps {
  issues: Issue[];
  onOpenIssue: (issueId: string) => void;
}

export function IssueGrid({ issues, onOpenIssue }: IssueGridProps): JSX.Element {
  if (issues.length === 0) {
    return <div className="notice">Tap + to add the first condition note in this room.</div>;
  }
  return (
    <div className="issue-grid">
      {issues.map((issue) => (
        <IssueCard key={issue.id} issue={issue} onOpen={() => onOpenIssue(issue.id)} />
      ))}
    </div>
  );
}
